import { FC } from 'react'
import DesktopNavigation from 'components/DesktopNavigation'
import { UserProtectedRoute } from 'routes'

const HelpInvoicesPage: FC = () => {
  return (
    <UserProtectedRoute>
      <DesktopNavigation label='Faktury' />
    </UserProtectedRoute>
  )
}

export default HelpInvoicesPage
